import { Building01Icon, ThumbsUpIcon, Timer01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { createFileRoute } from '@tanstack/react-router';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

export const Route = createFileRoute('/_authenticated/parts-management/suppliers')({
  component: PartsSuppliers,
});

function PartsSuppliers() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-balance">Parts Suppliers</h1>
        <p className="text-muted-foreground">Performance benchmarks and lead time reliability.</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {[
          {
            title: 'Approved Suppliers',
            value: '48',
            hint: '18 strategic partners',
            icon: Building01Icon,
          },
          {
            title: 'On-Time Delivery',
            value: '92%',
            hint: 'Rolling 90-day average',
            icon: Timer01Icon,
          },
          {
            title: 'Quality Score',
            value: '4.6 / 5',
            hint: 'Based on 312 inspections',
            icon: ThumbsUpIcon,
          },
        ].map((metric) => (
          <Card key={metric.title}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">{metric.title}</CardTitle>
              <HugeiconsIcon icon={metric.icon} className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-xl font-semibold">{metric.value}</div>
              <p className="text-xs text-muted-foreground">{metric.hint}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Supplier Scorecard</CardTitle>
          <CardDescription>Quarterly evaluation summary</CardDescription>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Supplier</TableHead>
                <TableHead>Category</TableHead>
                <TableHead>On-Time</TableHead>
                <TableHead>Quality</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {[
                {
                  name: 'MotionTech Components',
                  category: 'Mechanical',
                  ontime: '96%',
                  quality: '4.8',
                  status: 'Preferred',
                },
                {
                  name: 'VoltPrime Solutions',
                  category: 'Electrical',
                  ontime: '91%',
                  quality: '4.5',
                  status: 'Approved',
                },
                {
                  name: 'HydroFlow Services',
                  category: 'Hydraulics',
                  ontime: '87%',
                  quality: '4.4',
                  status: 'Watch',
                },
                {
                  name: 'Rapid Logistics',
                  category: 'Consumables',
                  ontime: '94%',
                  quality: '4.6',
                  status: 'Preferred',
                },
              ].map((row) => (
                <TableRow key={row.name}>
                  <TableCell className="font-medium">{row.name}</TableCell>
                  <TableCell>{row.category}</TableCell>
                  <TableCell className="tabular-nums text-muted-foreground">{row.ontime}</TableCell>
                  <TableCell className="tabular-nums text-muted-foreground">
                    {row.quality}
                  </TableCell>
                  <TableCell>
                    <Badge variant="secondary">{row.status}</Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
